import { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { fromJS, getIn } from 'immutable';
import { isNil, uniq } from 'lodash';
import mixpanel from 'mixpanel-browser';

// UTILS
import { isEmail, createCronString, getRevertedCronString } from 'utils';

// THUNKS
import { createRecurringEmail, updateRecurringEmail } from 'services/Views/thunks';

// SELECTORS
import { selectReportErrors } from 'services/Views/selectors';

// CONSTANTS
import {
  DEFAULT_FILE_FORMAT,
  FREQUENCY,
  FREQUENCY_TRANSLATIONS,
  DEFAULT_FREQUENCY,
  CONDITIONAL_FREQUENCY,
  TIME,
  TIME_TRANSLATIONS,
  DEFAULT_TIME,
  DAY_OF_WEEK,
  DAY_OF_WEEK_TRANSLATIONS,
  DEFAULT_DAY_OF_WEEK,
  DAY_OF_MONTH,
  DEFAULT_DAY_OF_MONTH,
} from 'constants/reports';
import { FLASH_MESSAGE_TYPES } from 'constants/common';
import { ANALYTICS_EVENTS } from 'constants/mixpanel.constants';

// COMPONENTS
import EmailsBox from 'components/EmailsBox';
import FileFormatSelection from 'components/FileFormat';
import FrequencyItemDropdown from './FrequencyItemDropdown';
import DropdownMenu, { CLASSES } from 'components/DropdownMenu';
import FlashMessage from 'components/FlashMessage';
import ErrorMessages from 'components/ErrorMessages';

// STYLES
import {
  Container,
  Relative,
  Modal,
  Header,
  Title,
  Label,
  Input,
  Close,
  Content,
  Footer,
  CancelButton,
  SaveButton,
} from 'styles/modals';
import { BorderedTextarea } from 'styles/form';
import { FieldContainer, FrequencySelection } from './styles';

class RecurringEmail extends Component {
  static defaultProps = {
    views: fromJS([]),
    report: undefined,
    onSaveSuccess: () => undefined,
  };

  state = {
    id: null,
    name: '',
    emails: [],
    subject: '',
    message: '',
    // @ts-expect-error TS(2339): Property 'views' does not exist on type 'Readonly<... Remove this comment to see the full error message
    selectedView: this.props.views.first(),
    fileFormat: DEFAULT_FILE_FORMAT,
    frequency: DEFAULT_FREQUENCY,
    time: DEFAULT_TIME,
    dayOfWeek: DEFAULT_DAY_OF_WEEK,
    dayOfMonth: DEFAULT_DAY_OF_MONTH,

    flashMessageVisible: false,
    flashMessageType: null,
    flashMessage: null,
  };

  componentDidUpdate = (prevProps) => {
    // @ts-expect-error TS(2339): Property 'visible' does not exist on type 'Readonl... Remove this comment to see the full error message
    if (prevProps.visible !== this.props.visible && document.body) {
      // @ts-expect-error TS(2339): Property 'visible' does not exist on type 'Readonl... Remove this comment to see the full error message
      if (this.props.visible) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'auto';
      }
    }

    // @ts-expect-error TS(2339): Property 'views' does not exist on type 'Readonly<... Remove this comment to see the full error message
    if (this.props.views && prevProps.views !== this.props.views) {
      // @ts-expect-error TS(2339): Property 'views' does not exist on type 'Readonly<... Remove this comment to see the full error message
      this.setState({ selectedView: this.props.views.first() });
    }

    // @ts-expect-error TS(2339): Property 'report' does not exist on type 'Readonly... Remove this comment to see the full error message
    if (prevProps.report !== this.props.report) {
      // @ts-expect-error TS(2339): Property 'report' does not exist on type 'Readonly... Remove this comment to see the full error message
      this.initializeReportState(this.props.report);
    }
  };

  initializeReportState = (report) => {
    const reportState = {
      id: null,
      name: '',
      emails: [],
      subject: '',
      message: '',
      // @ts-expect-error TS(2339): Property 'views' does not exist on type 'Readonly<... Remove this comment to see the full error message
      selectedView: this.props.views.first(),
      fileFormat: DEFAULT_FILE_FORMAT,
      frequency: DEFAULT_FREQUENCY,
      time: DEFAULT_TIME,
      dayOfWeek: DEFAULT_DAY_OF_WEEK,
      dayOfMonth: DEFAULT_DAY_OF_MONTH,
    };

    if (report) {
      reportState.id = report.get('id');
      reportState.name = report.get('name');
      reportState.emails = report.get('to').split(';');
      reportState.subject = report.get('subject');
      reportState.message = report.get('message');

      // @ts-expect-error TS(2339): Property 'views' does not exist on type 'Readonly<... Remove this comment to see the full error message
      const selectedReport = this.props.views.find((view) => report && view.get('id') === report.get('view'));

      // @ts-expect-error TS(2339): Property 'views' does not exist on type 'Readonly<... Remove this comment to see the full error message
      reportState.selectedView = selectedReport || this.props.views.first();
      reportState.fileFormat = report.get('fileFormat');

      const frequencyObject = getRevertedCronString(report.get('schedule'));

      reportState.frequency = frequencyObject.frequency;
      reportState.time = frequencyObject.time;
      reportState.dayOfWeek = frequencyObject.dayOfWeek || DEFAULT_DAY_OF_WEEK;
      reportState.dayOfMonth = frequencyObject.dayOfMonth || DEFAULT_DAY_OF_MONTH;
    }

    this.setState(reportState);
  };

  canSave = () => {
    if (
      this.state.name.length === 0 ||
      this.state.subject.length === 0 ||
      this.state.message.length === 0 ||
      !isEmail(this.state.emails) ||
      !this.state.selectedView ||
      !this.state.fileFormat
    ) {
      return false;
    }

    return true;
  };

  // List of views
  getDropdownViews = () =>
    // @ts-expect-error TS(2339): Property 'views' does not exist on type 'Readonly<... Remove this comment to see the full error message
    this.props.views.map((item) => ({
      translationId: item.get('name'),
      handleClick: this.handleSelectView(item),
    }));

  // Closes the modal
  handleCloseModal = () => {
    // @ts-expect-error TS(2339): Property 'loading' does not exist on type 'Readonl... Remove this comment to see the full error message
    if (this.props.loading) {
      return;
    }

    this.setState({
      name: '',
      emails: [],
      subject: '',
      message: '',
      // @ts-expect-error TS(2339): Property 'views' does not exist on type 'Readonly<... Remove this comment to see the full error message
      selectedView: this.props.views.first(),
      fileFormat: DEFAULT_FILE_FORMAT,
      frequency: DEFAULT_FREQUENCY,
      time: DEFAULT_TIME,
      dayOfWeek: DEFAULT_DAY_OF_WEEK,
      dayOfMonth: DEFAULT_DAY_OF_MONTH,
    });

    // @ts-expect-error TS(2339): Property 'onCloseModal' does not exist on type 'Re... Remove this comment to see the full error message
    this.props.onCloseModal();
  };

  // Changes a field in the form given the event value
  handleFieldChange = (name) => (event) => {
    this.handleChangeDirectField(name, event.currentTarget.value);
  };

  // Changes a field in the form
  handleChangeDirectField = (name, value) => {
    this.setState({ [name]: value });
  };

  // Changes the file format to be exported
  handleChangeFormat = (format) => {
    this.setState({ fileFormat: format });
  };

  // Updates the list of emails
  handleChangeEmails = (emails) => {
    this.setState({ emails });
  };

  // Selects a view as active
  handleSelectView = (view) => () => {
    this.setState({ selectedView: view });
  };

  // Saves the recurring email
  handleSaveRecurringEmail = () => {
    const recurringEmail = {
      name: this.state.name,
      to: uniq(this.state.emails).join(';'),
      subject: this.state.subject,
      message: this.state.message,
      view: getIn(this.state.selectedView, ['id']),
      fileFormat: this.state.fileFormat,
      schedule: createCronString(this.state.frequency, this.state.dayOfWeek, this.state.dayOfMonth, this.state.time),
    };
    const { id } = this.state;
    let savePromise = null;

    if (!isNil(id)) {
      // @ts-expect-error TS(2339): Property 'updateRecurringEmail' does not exist on ... Remove this comment to see the full error message
      savePromise = this.props.updateRecurringEmail(id, recurringEmail);
    } else {
      // @ts-expect-error TS(2339): Property 'createRecurringEmail' does not exist on ... Remove this comment to see the full error message
      savePromise = this.props.createRecurringEmail(recurringEmail);
    }

    savePromise
      .then(() => {
        // @ts-expect-error TS(2339): Property 'onSaveSuccess' does not exist on type 'R... Remove this comment to see the full error message
        this.props.onSaveSuccess(this.state.name);

        this.handleCloseModal();
      })
      .catch(() => {
        this.handleOpenFlashMessage(
          // @ts-expect-error TS(2339): Property 'intl' does not exist on type 'Readonly<{... Remove this comment to see the full error message
          this.props.intl.formatMessage({
            id: 'notification.recurringEmailError',
          }),
          FLASH_MESSAGE_TYPES.error
        );
      });
  };

  //=================================================
  //  Flash message related
  //=================================================

  // Opens the flash message
  handleOpenFlashMessage = (text, type) => {
    this.setState({
      flashMessageVisible: true,
      flashMessageType: type,
      flashMessage: text,
    });
  };

  // Closes the flash message
  handleCloseFlashMessage = () => {
    this.setState({
      flashMessageVisible: false,
      flashMessageType: null,
      flashMessage: null,
    });
  };

  render() {
    // @ts-expect-error TS(2339): Property 'visible' does not exist on type 'Readonl... Remove this comment to see the full error message
    if (!this.props.visible) {
      return null;
    }

    // @ts-expect-error TS(2339): Property 'intl' does not exist on type 'Readonly<{... Remove this comment to see the full error message
    const { formatMessage } = this.props.intl;
    const saveTranslationId = !isNil(this.state.id)
      ? 'components.Modals.CreateRecurringEmail.update'
      : 'components.Modals.CreateRecurringEmail.send';

    return (
      <Container>
        <FlashMessage
          visible={this.state.flashMessageVisible}
          type={this.state.flashMessageType}
          text={this.state.flashMessage}
          onClose={this.handleCloseFlashMessage}
        />

        <Relative>
          {/* @ts-expect-error TS(2769): No overload matches this call. */}
          <Modal loading={this.props.loading}>
            <Header>
              <Title>
                <FormattedMessage id="components.Modals.CreateRecurringEmail.title" />
              </Title>
              <Close
                onClick={() => {
                  // @ts-expect-error TS(2339): Property 'onCloseModal' does not exist on type 'Re... Remove this comment to see the full error message
                  this.props.onCloseModal();
                  mixpanel.track(ANALYTICS_EVENTS.CLOSE_MODAL);
                }}
                className="icon-close-light"
              />
            </Header>

            <Content>
              <FieldContainer>
                <Label>
                  <FormattedMessage id="components.Modals.CreateRecurringEmail.nameLabel" />
                </Label>
                <Input
                  type="text"
                  name="name"
                  value={this.state.name}
                  placeholder={formatMessage({
                    id: 'components.Modals.CreateRecurringEmail.namePlaceholder',
                  })}
                  onChange={this.handleFieldChange('name')}
                  // @ts-expect-error TS(2339): Property 'loading' does not exist on type 'Readonl... Remove this comment to see the full error message
                  disabled={this.props.loading}
                />
                {/* @ts-expect-error TS(2339): Property 'errors' does not exist on type 'Readonly... Remove this comment to see the full error message */}
                <ErrorMessages errors={this.props.errors.name} />
              </FieldContainer>

              <EmailsBox
                label={formatMessage({
                  id: 'components.Modals.CreateRecurringEmail.emailAddressesLabel',
                })}
                emails={this.state.emails}
                onChangeEmails={this.handleChangeEmails}
                visible
              />

              <FieldContainer>
                <Label>
                  <FormattedMessage id="components.Modals.CreateRecurringEmail.subjectLabel" />
                </Label>
                <Input
                  type="text"
                  name="subject"
                  value={this.state.subject}
                  placeholder={formatMessage({
                    id: 'components.Modals.CreateRecurringEmail.subjectPlaceholder',
                  })}
                  onChange={this.handleFieldChange('subject')}
                  // @ts-expect-error TS(2339): Property 'loading' does not exist on type 'Readonl... Remove this comment to see the full error message
                  disabled={this.props.loading}
                />
                {/* @ts-expect-error TS(2339): Property 'errors' does not exist on type 'Readonly... Remove this comment to see the full error message */}
                <ErrorMessages errors={this.props.errors.subject} />
              </FieldContainer>

              <FieldContainer>
                <Label>
                  <FormattedMessage id="components.Modals.CreateRecurringEmail.messageLabel" />
                </Label>
                <BorderedTextarea
                  name="message"
                  value={this.state.message}
                  placeholder={formatMessage({
                    id: 'components.Modals.CreateRecurringEmail.messagePlaceholder',
                  })}
                  onChange={this.handleFieldChange('message')}
                  // @ts-expect-error TS(2339): Property 'loading' does not exist on type 'Readonl... Remove this comment to see the full error message
                  disabled={this.props.loading}
                  // @ts-expect-error TS(2769): No overload matches this call.
                  rows="5"
                />
                {/* @ts-expect-error TS(2339): Property 'errors' does not exist on type 'Readonly... Remove this comment to see the full error message */}
                <ErrorMessages errors={this.props.errors.message} />
              </FieldContainer>

              <FieldContainer>
                <Label>
                  <FormattedMessage id="components.Modals.CreateRecurringEmail.viewLabel" />
                </Label>
                <DropdownMenu
                  renderedValue={getIn(this.state.selectedView, ['name'], '')}
                  items={this.getDropdownViews()}
                  className={`${CLASSES.FULL_WIDTH}`}
                  button
                />
              </FieldContainer>

              <FieldContainer>
                <FileFormatSelection
                  label={formatMessage({
                    id: 'components.Modals.CreateRecurringEmail.fileFormatLabel',
                  })}
                  selectedFormat={this.state.fileFormat}
                  onSelectFormat={this.handleChangeFormat}
                />
              </FieldContainer>

              <Label>
                <FormattedMessage id="components.Modals.CreateRecurringEmail.frequencyLabel" />
              </Label>
              <FrequencySelection>
                <FrequencyItemDropdown
                  selected={this.state.frequency}
                  options={FREQUENCY}
                  translations={FREQUENCY_TRANSLATIONS}
                  name="frequency"
                  onSelectOption={this.handleChangeDirectField}
                  top
                />

                <FrequencyItemDropdown
                  visible={this.state.frequency === CONDITIONAL_FREQUENCY.weekly}
                  selected={this.state.dayOfWeek}
                  options={DAY_OF_WEEK}
                  translations={DAY_OF_WEEK_TRANSLATIONS}
                  name="dayOfWeek"
                  textBefore="components.Modals.CreateRecurringEmail.on"
                  onSelectOption={this.handleChangeDirectField}
                  top
                />

                <FrequencyItemDropdown
                  visible={this.state.frequency === CONDITIONAL_FREQUENCY.monthly}
                  selected={this.state.dayOfMonth}
                  options={DAY_OF_MONTH}
                  name="dayOfMonth"
                  textBefore="components.Modals.CreateRecurringEmail.on"
                  onSelectOption={this.handleChangeDirectField}
                  top
                />

                <FrequencyItemDropdown
                  selected={this.state.time}
                  options={TIME}
                  translations={TIME_TRANSLATIONS}
                  name="time"
                  textBefore="components.Modals.CreateRecurringEmail.at"
                  textAfter="components.Modals.CreateRecurringEmail.timezone"
                  onSelectOption={this.handleChangeDirectField}
                  top
                />
              </FrequencySelection>
            </Content>

            <Footer>
              {/* @ts-expect-error TS(2339): Property 'loading' does not exist on type 'Readonl... Remove this comment to see the full error message */}
              <CancelButton onClick={this.handleCloseModal} disabled={this.props.loading} />
              {/* @ts-expect-error TS(2339): Property 'loading' does not exist on type 'Readonl... Remove this comment to see the full error message */}
              <SaveButton onClick={this.handleSaveRecurringEmail} disabled={this.props.loading || !this.canSave()}>
                <FormattedMessage id={saveTranslationId} />
              </SaveButton>
            </Footer>
          </Modal>
        </Relative>
      </Container>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  errors: selectReportErrors(),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      createRecurringEmail,
      updateRecurringEmail,
    },
    dispatch
  );

// @ts-expect-error TS(2345): Argument of type 'ConnectedComponent<FC<WithIntlPr... Remove this comment to see the full error message
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(RecurringEmail)));
